import type { Ref, RefAttributes, ReactNode } from "react";
import classNames from "classnames/dedupe";

export interface HeaderCellProps extends RefAttributes<HTMLTableCellElement> {
  children?: ReactNode;
  className?: string;
  colSpan?: number;
  rowSpan?: number;
}

export type HeaderCellRef = Ref<HTMLTableCellElement>;

const HeaderCell = ({ ref, ...props }: HeaderCellProps) => {
  const classes = classNames(
    "mobius",
    "mobius-table__head-cell",
    props.className,
  );

  return <th {...props} ref={ref} className={classes} />;
};

HeaderCell.displayName = "Table.HeaderCell";
export { HeaderCell };
